import { nullable } from '@infl-ts/util-io-ts';
import * as t from 'io-ts';
var Language = t.type({
  code: t.string
});
export var Profile = t.type({
  email: t.string,
  id: t.string,
  name: t.string,
  avatarUrl: nullable(t.string),
  timezone: nullable(t.string),
  isAdmin: t["boolean"],
  isClone: t["boolean"],
  language: Language
});
export var PrimaryAdmins = t.array(t.type({
  id: t.string
}));
export var ChatConfigsQuery = t.type({
  profile: Profile,
  primaryAdmins: PrimaryAdmins
});
export var StreamUser = t.type({
  banned: t["boolean"],
  created_at: t.string,
  id: t.string,
  name: t.string,
  online: t["boolean"],
  role: t.string,
  shadow_banned: t["boolean"]
});
export var FetchUsersResponse = t.type({
  users: t.array(StreamUser)
});
export var StreamToken = t.type({
  token: t.string,
  username: t.string,
  image: t.string,
  name: t.string
});